import styled, { css } from "styled-components";

const LevelTd = styled.td`
  ${props =>
    props &&
    props.level &&
    css`
      padding-left: ${props.level * 30}px!important;
    `}
  ${props =>
    props &&
    props.disabled &&
    css`
      text-decoration: line-through;
    `}
`;
export default LevelTd;
